// ABOUTME: Connects gameStore activity to celebration system
// ABOUTME: Watches for level-ups and achievements to trigger celebrations

import { useEffect } from 'react'
import { useGameState, useUpdateGameState } from '@/hooks/useGameState'
import { useCelebrationContext } from '@/components/providers/CelebrationProvider'

export function useGameCelebrations() {
  const { data: gameState } = useGameState()
  const level = gameState?.level ?? 1
  const levelAcknowledged = gameState?.levelAcknowledged ?? 1
  const { triggerLevelUp } = useCelebrationContext()
  const { mutate: acknowledgeLevel } = useUpdateGameState()

  useEffect(() => {
    if (level > levelAcknowledged) {
      triggerLevelUp(level)
      acknowledgeLevel({ levelAcknowledged: level })
    }
  }, [level, levelAcknowledged, triggerLevelUp, acknowledgeLevel])
}
